import React from 'react'
import Image from 'next/image'

import CustomLink from 'components/Link/CustomLink'

import style from './FeaturedPost.module.scss'

import { BASE_WP_API_URL } from 'config/cms'

import {
  getCategoryLink,
  getCategorySlug,
  getDisplayCategory,
} from 'utils/Blog'
import getWordpressCloudinaryId from 'utils/strings/getWordpressCloudinaryId'
import cloudinaryLoader from 'utils/imageLoaders/cloudinaryLoader'

type FeaturedPostProps = {
  topFeaturedPost: boolean
  categoryData: unknown
  data: {
    categories: number[]
    formatted_categories: string[]
    slug: string
    renderedTitle: string
    featured_image_url: string
    excerpt: { rendered: string }
  }
}

const FeaturedPost: React.FC<FeaturedPostProps> = ({
  data,
  topFeaturedPost,
  categoryData,
}) => {
  const {
    categories,
    formatted_categories,
    slug,
    renderedTitle,
    featured_image_url,
    excerpt,
  } = data
  const category = getDisplayCategory(categories, formatted_categories)

  const categorySlug = getCategorySlug(categoryData, category)

  return (
    <div
      className={`${style.featuredPost} ${
        topFeaturedPost ? style.topFeaturedPost : ''
      }`}
    >
      <CustomLink
        className={`${style.featuredPostLink} post-link`}
        href={`/blog/${categorySlug}/${slug}`}
        title={renderedTitle}
      >
        {' '}
      </CustomLink>
      <div className={style.featuredImage}>
        {featured_image_url &&
          (getWordpressCloudinaryId(featured_image_url) ? (
            <div className="image is-16by9">
              <Image
                alt={renderedTitle}
                fill
                loader={cloudinaryLoader}
                priority={topFeaturedPost}
                sizes={
                  topFeaturedPost
                    ? '(min-width: 1024px) calc(((100vw - 10rem) * 0.61) - 1rem), calc(100vw - 6rem)'
                    : '(min-width: 1024px) calc(((100vw - 10rem) * 0.38) * 0.52 - 20px), calc(100vw - 6rem)'
                }
                src={getWordpressCloudinaryId(featured_image_url)!}
                style={{
                  objectFit: 'cover',
                }}
              />
            </div>
          ) : (
            BASE_WP_API_URL &&
            featured_image_url.includes(BASE_WP_API_URL) && (
              <div className="image is-16by9">
                <Image
                  alt={renderedTitle}
                  fill
                  loader={cloudinaryLoader}
                  priority={topFeaturedPost}
                  sizes={
                    topFeaturedPost
                      ? '(min-width: 1024px) calc(((100vw - 10rem) * 0.61) - 1rem), calc(100vw - 6rem)'
                      : '(min-width: 1024px) calc(((100vw - 10rem) * 0.38) * 0.52 - 20px), calc(100vw - 6rem)'
                  }
                  src={featured_image_url}
                  style={{
                    objectFit: 'cover',
                  }}
                />
              </div>
            )
          ))}
      </div>
      <div className={style.postContent}>
        {category ? (
          <div className={style.category}>
            <CustomLink
              className="category-link"
              href={getCategoryLink(categorySlug)}
              prefetch={false}
              title={category.name}
            >
              {category.name}
            </CustomLink>
          </div>
        ) : (
          ''
        )}
        <h3 className={style.title}>{renderedTitle}</h3>
        {excerpt && (
          <div
            className={style.excerpt}
            dangerouslySetInnerHTML={{ __html: excerpt.rendered }}
          />
        )}
      </div>
    </div>
  )
}

export default FeaturedPost
